import React, { useEffect, useState } from "react";
import Select from "react-select";
import PageHeader from "../../../components/common/PageHeader";
import { useParams } from "react-router-dom";
import { VERTICALS } from "../../../constants/verticals";
import { exportInquiryReport, exportNotAttended30DaysReport, getInquiryReport, getNotAttended30DaysReport } from "../api/reportService";
import { getChannelList, getClientSegmentByVertical, getInquirySourceList, getPLList, getProbabilityList, getResponsibleUsers } from "../../sales/inquiry/api/inquiry.api";
import { getClientList } from "../../client/api/clientService";
import "../styles/salesReport.css";
type SelectOption = {
    label: string;
    value: number | string;
};

type FiltersType = {
    client_name: SelectOption | null;
    project_name: string;
    client_segment: SelectOption | null;
    platform: SelectOption | null;
    architect: string;
    responsible_person: SelectOption | null;
    assigned_to: SelectOption | null;
    city: string;
    area: string;
    source: SelectOption | null;
    channel: SelectOption | null;
    probability: SelectOption | null;
    facade_consultant: string;
    date_from: string;
    date_to: string;
};
const formatDate = (dateString: string | null) => {
    if (!dateString) return "-";

    const date = new Date(dateString);

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
};
const NotAttended30DaysReport: React.FC = () => {

    const { vertical } = useParams<{ vertical: string }>();

    const verticalConfig = VERTICALS.find(v => v.key === vertical);

    const verticalId = verticalConfig?.id;
    const verticalName = verticalConfig?.label || "";
    const [clientOptions, setClientOptions] = useState<any[]>([]);
    const [segmentOptions, setSegmentOptions] = useState<any[]>([]);
    const [plOptions, setPlOptions] = useState<any[]>([]);
    const [channelOptions, setChannelOptions] = useState<any[]>([]);
    const [responsibleOptions, setResponsibleOptions] = useState<any[]>([]);
    const [sourceOptions, setSourceOptions] = useState<any[]>([]);
    const [probabilityOptions, setProbabilityOptions] = useState<any[]>([]);
    const [dateError, setDateError] = useState<string>("");

    const [list, setList] = useState<any[]>([]);
    const [page, setPage] = useState(1);
    const [totalCount, setTotalCount] = useState(0);
    const [pageSize, setPageSize] = useState<number | null>(null);
    // const [hasGenerated, setHasGenerated] = useState(false);
    const defaultFilters: FiltersType = {
        client_name: null,
        project_name: "",
        client_segment: null,
        platform: null,
        architect: "",
        responsible_person: null,
        assigned_to: null,
        city: "",
        area: "",
        source: null,
        channel: null,
        probability: null,
        facade_consultant: "",
        date_from: "",
        date_to: "",
    };

    const [filters, setFilters] = useState<FiltersType>(defaultFilters);


    const buildApiFilters = () => ({
        vertical: verticalId,
        // ...filters,
        // client_name: filters.client_name?.label || "",
        // client_segment: filters.client_segment?.label || "",
        // platform: filters.platform?.label || "",
        // responsible_person: filters.responsible_person?.label || "",
        // assigned_to: filters.assigned_to?.label || "",
        // source: filters.source?.label || "",
        // channel: filters.channel?.label || "",
        // probability: filters.probability?.label || "",
    });
    useEffect(() => {
        // Reset everything when vertical changes
        setFilters(defaultFilters);
        setList([]);
        setPage(1);
        setTotalCount(0);
        setPageSize(null);
        // setHasGenerated(false);
        setDateError("");
    }, [verticalId]);
    const validateDates = () => {
        const { date_from, date_to } = filters;

        if (!date_from || !date_to) {
            setDateError("");
            return true;
        }

        const from = new Date(date_from);
        const to = new Date(date_to);

        if (from > to) {
            setDateError("From Date cannot be greater than To Date");
            return false;
        }

        setDateError("");
        return true;
    };

    useEffect(() => {
        if (!verticalId) return;

        const loadMasters = async () => {
            try {

                const [
                    clientsRes,
                    segmentRes,
                    plRes,
                    channelRes,
                    responsibleRes,
                    sourceRes
                ] = await Promise.all([
                    getClientList(1, {}),
                    getClientSegmentByVertical(verticalId),
                    getPLList(verticalId),
                    getChannelList({ page: 1 }),
                    getResponsibleUsers({ vertical_id: verticalId }),
                    getInquirySourceList(),
                ]);

                setClientOptions(
                    clientsRes.data.results.map((c: any) => ({
                        label: c.name,
                        value: c.id,
                    }))
                );

                setSegmentOptions(
                    segmentRes.data.results.map((s: any) => ({
                        label: s.name,
                        value: s.id,
                    }))
                );

                setPlOptions(
                    plRes.data.results.map((p: any) => ({
                        label: p.name,
                        value: p.id,
                    }))
                );

                setChannelOptions(
                    channelRes.data.results.map((c: any) => ({
                        label: c.name,
                        value: c.id,
                    }))
                );

                setResponsibleOptions(
                    responsibleRes.data.data.map((u: any) => ({
                        label: u.name,
                        value: u.id,
                    }))
                );

                setSourceOptions(
                    sourceRes.data.results.map((s: any) => ({
                        label: s.name,
                        value: s.id,
                    }))
                );

            } catch (err) {
                console.error("Master load failed");
            }
        };

        loadMasters();
    }, [verticalId]);
    useEffect(() => {
        if (!verticalId) return;

        const loadProbability = async () => {
            try {
                const res = await getProbabilityList();

                setProbabilityOptions(
                    res.data.results
                        .filter((p: any) => p.is_active)
                        .map((p: any) => ({
                            label: p.name,
                            value: p.id,
                        }))
                );
            } catch {
                console.error("Probability load failed");
            }
        };

        loadProbability();
    }, [verticalId]);


    /* ================= FETCH ================= */
    const fetchReport = async (pageNo: number) => {
        if (!verticalId) return;

        const res = await getNotAttended30DaysReport(pageNo, buildApiFilters());

        setList(res.data.results || []);
        setTotalCount(res.data.count || 0);

        if (pageSize === null && res.data.results?.length) {
            setPageSize(res.data.results.length);
        }
    };
    /* ================= PAGINATION FETCH ================= */
    // useEffect(() => {
    //     if (hasGenerated) {
    //         fetchReport(page);
    //     }
    // }, [page, filters]);   // optional but recommended

    useEffect(() => {
  if (!verticalId) return;

  fetchReport(page);
}, [page, verticalId]);

    const handleExport = async () => {
        const res = await exportNotAttended30DaysReport(buildApiFilters());

        const blob = new Blob([res.data], {
            type: "text/csv;charset=utf-8;",
        });

        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "Not_Attended_30_Days_Report.csv";
        a.click();

        window.URL.revokeObjectURL(url);
    };
    const totalPages =
        pageSize && totalCount ? Math.ceil(totalCount / pageSize) : 1;

    const handleClear = () => {
        setFilters(defaultFilters);
        setList([]);
        setPage(1);
        // setHasGenerated(false);
    };

    const formatDate = (date?: string | null) => {
        if (!date) return "-";

        // already dd-mm-yyyy
        if (/^\d{2}-\d{2}-\d{4}$/.test(date)) {
            return date;
        }

        let d: Date;

        // handle MM/DD/YY or MM/DD/YYYY
        if (date.includes("/")) {
            const parts = date.split("/");

            let month = Number(parts[0]);
            let day = Number(parts[1]);
            let year = Number(parts[2]);

            // convert 2-digit year → 4-digit
            if (year < 100) {
                year += 2000;
            }

            d = new Date(year, month - 1, day);
        } else {
            // ISO or other format
            d = new Date(date);
        }

        if (isNaN(d.getTime())) return "-";

        const day = String(d.getDate()).padStart(2, "0");
        const month = String(d.getMonth() + 1).padStart(2, "0");
        const year = d.getFullYear();

        return `${day}-${month}-${year}`;
    };
    return (
        <>
            <PageHeader
                title={`${verticalName} – Not Attended in Last 30 Days`}
                breadcrumbs={[
                    { label: "Dashboard", path: "/dashboard" },
                    { label: "Reports" },
                    { label: verticalName },
                ]}
            />
            <div className="container mt-4">
                {/* FILTER CARD */}
                {/* <div className="card p-4">

               
                    <div className="row mb-3">
                        <div className="col-md-3">
                            <label className="form-label fw-semibold my-1">From Date</label>
                            <div className="form-floating">
                                <input
                                    type="date"
                                    className="form-control"
                                    placeholder="From Date"
                                    value={filters.date_from}
                                    onChange={(e) =>
                                        setFilters(prev => ({
                                            ...prev,
                                            date_from: e.target.value,
                                        }))
                                    }
                                    max={filters.date_to || undefined}

                                />
                                <label>From Date</label>
                            </div>
                        </div>

                        <div className="col-md-3">
                            <label className="form-label fw-semibold my-1">To Date</label>

                            <div className="form-floating">
                                <input
                                    type="date"
                                    className="form-control"
                                    placeholder="To Date"
                                    value={filters.date_to}
                                    min={filters.date_from || undefined}

                                    onChange={(e) =>
                                        setFilters(prev => ({
                                            ...prev,
                                            date_to: e.target.value,
                                        }))
                                    }
                                />
                                <label>To Date</label>
                            </div>
                        </div>


                    </div>

                
                    <div className="row g-3">

                
                        <div className="col-md-3 stage-list">
                            <div className="form-group">
                                <label className="form-label fw-semibold my-1">Client Name</label>
                                <Select
                                    options={clientOptions}
                                    value={filters.client_name}
                                    onChange={(v) => setFilters(prev => ({ ...prev, client_name: v }))}

                                    placeholder="Select Client"
                                    classNamePrefix="react-select"
                                />
                            </div>
                        </div>

                 
                        <div className="col-md-3">
                            <label className="form-label fw-semibold my-1">Project Name</label>
                            <div className="form-floating">
                                <input
                                    className="form-control"
                                    placeholder="Project Name"
                                    value={filters.project_name}
                                    onChange={(e) =>
                                        setFilters(prev => ({ ...prev, project_name: e.target.value }))
                                    }
                                />
                                <label>Project Name</label>
                            </div>
                        </div>

                      
                        <div className="col-md-3 stage-list">
                            <div className="form-group">
                                <label className="form-label fw-semibold my-1">Client Segment</label>
                                <Select
                                    options={segmentOptions}
                                    value={filters.client_segment}
                                    onChange={(v) => setFilters(prev => ({ ...prev, client_segment: v }))}
                                    placeholder="Segment"
                                    classNamePrefix="react-select"
                                />
                            </div>
                        </div>

                       
                        <div className="col-md-3 stage-list">
                            <div className="form-group">
                                <label className="form-label fw-semibold my-1">PL</label>
                                <Select
                                    options={plOptions}
                                    value={filters.platform}
                                    onChange={(v) =>
                                        setFilters(prev => ({
                                            ...prev,
                                            platform: v
                                        }))
                                    }
                                    placeholder="PL"
                                    classNamePrefix="react-select"
                                />
                            </div>
                        </div>

                       
                        <div className="col-md-3">
                            <label className="form-label fw-semibold my-1">Client Architect Name</label>
                            <div className="form-floating">
                                <input
                                    className="form-control"
                                    placeholder="Client Architect Name"
                                    value={filters.architect}
                                    onChange={(e) =>
                                        setFilters(prev => ({ ...prev, architect: e.target.value }))
                                    }
                                />
                                <label>Client Architect Name</label>
                            </div>
                        </div>
                       
                        <div className="col-md-3 stage-list">
                            <div className="form-group">
                                <label className="form-label fw-semibold my-1">Responsible Person</label>
                                <Select
                                    options={responsibleOptions}
                                    value={filters.responsible_person}
                                    onChange={(v) =>
                                        setFilters(prev => ({
                                            ...prev,
                                            responsible_person: v
                                        }))
                                    }
                                    placeholder="Responsible"
                                    classNamePrefix="react-select"
                                />
                            </div>
                        </div>

                       
                        <div className="col-md-3 stage-list">
                            <div className="form-group">
                                <label className="form-label fw-semibold my-1">Assign To</label>
                                <Select
                                    options={responsibleOptions}
                                    value={filters.assigned_to}
                                    onChange={(v) =>
                                        setFilters(prev => ({
                                            ...prev,
                                            assigned_to: v
                                        }))
                                    }
                                    placeholder="Assign To"
                                    classNamePrefix="react-select"
                                />
                            </div>
                        </div>

                       
                        <div className="col-md-3">
                            <label className="form-label fw-semibold my-1">City</label>
                            <div className="form-floating">
                                <input
                                    className="form-control"
                                    placeholder="City"
                                    value={filters.city}
                                    onChange={(e) =>
                                        setFilters(prev => ({ ...prev, city: e.target.value }))
                                    }
                                />
                                <label>City</label>
                            </div>
                        </div>

                       
                        <div className="col-md-3">
                            <label className="form-label fw-semibold my-1">Area</label>
                            <div className="form-floating">
                                <input
                                    className="form-control"
                                    placeholder="Area"
                                    value={filters.area}
                                    onChange={(e) =>
                                        setFilters(prev => ({ ...prev, area: e.target.value }))
                                    }
                                />
                                <label>Area</label>
                            </div>
                        </div>

                       
                        <div className="col-md-3 stage-list">
                            <div className="form-group">
                                <label className="form-label fw-semibold my-1">Inquiry Source</label>
                                <Select
                                    options={sourceOptions}
                                    value={filters.source}
                                    onChange={(v) =>
                                        setFilters(prev => ({
                                            ...prev,
                                            source: v
                                        }))
                                    }
                                    placeholder="Source"
                                    classNamePrefix="react-select"
                                />
                            </div>
                        </div>

                       
                        <div className="col-md-3">
                            <label className="form-label fw-semibold my-1">Facade Consultant</label>
                            <div className="form-floating">
                                <input
                                    className="form-control"
                                    placeholder="Facade Consultant"
                                    value={filters.facade_consultant}
                                    onChange={(e) =>
                                        setFilters(prev => ({ ...prev, facade_consultant: e.target.value }))
                                    }
                                />
                                <label>Facade Consultant</label>
                            </div>
                        </div>

                       
                        <div className="col-md-3 stage-list">
                            <div className="form-group">
                                <label className="form-label fw-semibold my-1">Channel</label>
                                <Select
                                    options={channelOptions}
                                    value={filters.channel}
                                    onChange={(v) =>
                                        setFilters(prev => ({
                                            ...prev,
                                            channel: v
                                        }))
                                    }
                                    placeholder="Channel"
                                    classNamePrefix="react-select"
                                />
                            </div>
                        </div>

                       
                        <div className="col-md-3 stage-list">
                            <div className="form-group">
                                <label className="form-label fw-semibold my-1">Probability</label>
                                <Select
                                    options={probabilityOptions}
                                    value={filters.probability}
                                    onChange={(v) =>
                                        setFilters(prev => ({
                                            ...prev,
                                            probability: v
                                        }))
                                    }
                                    placeholder="Probability"
                                    classNamePrefix="react-select"
                                />
                            </div>
                        </div>

                    </div>

                    <div className="mt-4 d-flex align-item-end justify-content-end gap-2">

                        <button
                            className="btn btn-outline-secondary"
                            onClick={handleClear}
                        >
                            Clear
                        </button>

                        <button
                            className="btn btn-primary"
                            onClick={() => {
                                if (!validateDates()) return;

                                setPage(1);
                                // setHasGenerated(true);
                                fetchReport(1);
                            }}

                        >
                            Generate
                        </button>
                    </div>

                </div> */}


                {/* TABLE */}
                <div className="card p-4 mt-4">
                    <div className="my-2 d-flex align-item-end justify-content-end gap-2">
                        <button
                            className="btn btn-primary"
                            onClick={handleExport}
                        >
                            Export CSV
                        </button></div>
                    <div className="table-responsive">
                        <table className="table table-hover mb-0 report-table">
                            <thead>
                                <tr>
                                    <th>Inquiry Number</th>
                                    <th>Client Name</th>
                                    <th>Project Name</th>
                                    <th>Client Segment</th>
                                    <th>PL</th>
                                    <th>Responsible Person</th>
                                    <th>Assign To</th>
                                    <th>City</th>
                                    <th>Area</th>
                                    <th>Inquiry Source</th>
                                    <th>Channel</th>
                                    <th>Status</th>
                                    <th>Facade Consultant</th>
                                    <th>Latest Activity</th>
                                    <th>Created Date</th>
                                </tr>
                            </thead>

                            <tbody>
                                {list.length === 0 ? (
                                    <tr>
                                        <td colSpan={13} className="text-center py-4">
                                            No Data Found
                                        </td>
                                    </tr>
                                ) : (
                                    list.map((row, i) => (
                                        <tr key={row.id || i}>
                                            <td>{row.id}</td>

                                            <td>{row.client_name}</td>
                                            <td>{row.project_name}</td>
                                            <td>{row.client_segment}</td>
                                            <td>{row.platform}</td>
                                            <td>{row.responsible_person || "-"}</td>
                                            <td>{row.inquiry_assigned_to || "-"}</td>
                                            <td>{row.city}</td>
                                            <td>{row.area}</td>
                                            <td>{row.source}</td>
                                            <td>{row.channel}</td>
                                            <td>{row.current_stage}</td>
                                            <td>{row.facade_consultant}</td>
                                            <td style={{ textAlign: "center" }}>
                                                {formatDate(row.last_activity)}
                                            </td>

                                            {/* ✅ CREATED DATE */}
                                            <td style={{ textAlign: "center" }}>
                                                {formatDate(row.created_date)}  {/* or row.created_date */}
                                            </td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    </div>

                    {totalPages > 1 && (
                        <div className="d-flex justify-content-end gap-1 p-3">
                            <button
                                className="btn btn-sm btn-outline-secondary"
                                disabled={page === 1}
                                onClick={() => setPage(page - 1)}
                            >
                                Prev
                            </button>

                            {Array.from({ length: totalPages }, (_, i) => i + 1).map(p => (
                                <button
                                    key={p}
                                    className={`btn btn-sm ${p === page ? "btn-primary" : "btn-outline-secondary"}`}
                                    onClick={() => setPage(p)}
                                >
                                    {p}
                                </button>
                            ))}

                            <button
                                className="btn btn-sm btn-outline-secondary"
                                disabled={page === totalPages}
                                onClick={() => setPage(page + 1)}
                            >
                                Next
                            </button>
                        </div>
                    )}
                </div>

            </div>
        </>
    );
};

export default NotAttended30DaysReport;